/**
 * Resource danh sách phiếu chi
 * ntduong2 26/4/2023
 */
export default {
  Title: 'Danh sách phiếu chi',
  DetailTitle: 'Phiếu chi tiền',
  AccountingObject: 'Người nhận',
  Name: 'Họ tên',
  Address: 'Địa chỉ',
  AccountBank: 'TKKB',
  AccountBankTitle: 'Tài khoản kho bạc',
  Description: 'Diễn giải',
  Include: 'Kèm theo',
  VoucherRef: 'CT tham chiếu',
  VoucherRefTitle: 'Chứng từ tham chiếu',
  RefDate: 'Ngày PC',
  RefDateTitle: 'Ngày phiếu chi',
  PostedDate: 'Ngày HT',
  PostedDateTitle: 'Ngày hạch toán',
  RefNo: 'Số PC',
  RefNoTitle: 'Số phiếu chi',
  ThirdRefNo: 'Số GBC',
  ThirdRefNoTitle: 'Số giấy báo chi',
  Popup:{
    Title: 'Tùy chọn in',
    NotShowAgain: 'Không hiển thị lại',
    ShowReceiptEnoughMoney: 'Hiển thị đã nhận đủ số tiền trên Phiếu chi',
  }
};
